import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { getActivitySectors } from '../../../api';

const SectorSelector = (props) => {

    const defaultOption = {value: null, name: "ACTIVITY SECTOR"}
    const emptyOption = {value: null, name: props.literals.L20901}

    const [activitySectors, setActivitySectors] = useState([]);
    const [sectorsSelect1, setSectorsSelect1] = useState([]);
    const [sectorsSelect2, setSectorsSelect2] = useState([]);
    const [sectorsSelect3, setSectorsSelect3] = useState([]);
    const [thirdSelectDisabled, setThirdSelectDisabled] = useState(true)
    const [sector1, setSector1] = useState({value: null});
    const [sector2, setSector2] = useState({value: null, name: "ACTIVITY SECTOR"});
    const [sector3, setSector3] = useState({value: null, name: "ACTIVITY SECTOR"});

    useEffect(() => {
        getActivitySectors(props.indicator)
        .then((res) => {
            setActivitySectors(res.resultset);
            setSectorsSelect1(res.resultset);
        })
    }, [props.indicator]);

    useEffect(() => {
        setSector1(activitySectors[0]);
    }, [activitySectors])

    useEffect(() => {
        if (sector1 != undefined)
        {
            props.handleSector1Change(sector1.value);
        }
    }, [sector1])

    useEffect(() => {
        if (sector2.value != null)
        {
            setThirdSelectDisabled(false)
        }
        else
        {
            setSector3(defaultOption);
            setThirdSelectDisabled(true)
        }
        props.handleSector2Change(sector2.value);
    }, [sector2])

    useEffect(() => {
        props.handleSector3Change(sector3.value);
    }, [sector3])

    useEffect(() => {
        setSectorsSelect1(activitySectors.filter((sector) => sector.value != sector2.value && sector.value != sector3.value));
    }, [sector2, sector3])

    useEffect(() => {
        let sectors = activitySectors.filter((sector) => sector.value != sector1.value && sector.value != sector3.value);
        if (sector2.value != null)
        {
            sectors.unshift(emptyOption)
        }
        setSectorsSelect2(sectors);
    }, [sector1, sector3])

    useEffect(() => {
        let sectors = activitySectors.filter((sector) => sector.value != sector1.value && sector.value != sector2.value);
        if (sector3.value != null)
        {
            sectors.unshift(emptyOption)
        }
        setSectorsSelect3(sectors);
    }, [sector1, sector2])

    const handleSelectChangeSector1 = (element) => {
        setSector1(element);
	}

    const handleSelectChangeSector2 = (element) => {
        
        if (element.value != null)
        {
            let sectors = sectorsSelect2;
            sectors.unshift(emptyOption)
            setSectorsSelect2(sectors);
            setSector2(element);            
        }
        else
        {
            setSector2(defaultOption);
        }
	}

    const handleSelectChangeSector3 = (element) => {
        if (element.value != null)
        {
            let sectors = sectorsSelect3;
            sectors.unshift(emptyOption)
            setSectorsSelect3(sectors);
            setSector3(element);            
        }
        else
        {
            setSector3(defaultOption);
        }
	}

    return (
        <div className="compare--block container">
            <ul className="compare--list">
                <li>
                    <label>FIRST ACTIVITY SECTOR</label>
                    <Select
                        onChange={handleSelectChangeSector1}
                        value={sector1}
                        className="select-component select2-container"
                        isSearchable
                        options={sectorsSelect1}
                        getOptionLabel={option => option.name}
                    />
                </li>
                <li>
                    <label>SECOND ACTIVITY SECTOR</label>
                    <Select
                        onChange={handleSelectChangeSector2}
                        value={sector2}
                        className="select-component select2-container"
                        isSearchable
                        options={sectorsSelect2}
                        getOptionLabel={option => option.name}
                    />
                </li>
                <li>
                    <label>THIRD ACTIVITY SECTOR</label>
                    <Select
                        onChange={handleSelectChangeSector3}
                        value={sector3}
                        className="select-component select2-container"
                        isSearchable
                        isDisabled = { thirdSelectDisabled }
                        options={sectorsSelect3}
                        getOptionLabel={option => option.name}
                    />
                </li>
            </ul>
        </div>
    )
}

export default SectorSelector;